// extracted by mini-css-extract-plugin
module.exports = {"contacts":"_772e1b1e50--contacts--z0b8M","button":"_772e1b1e50--button--q97_2"};